import { Component, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

export interface BreadcrumbItem {
  label: string;
  url?: string;
  reload?: boolean;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent {
  @Input() items: BreadcrumbItem[] = [];
  
  isLoading: boolean = false;
  currentUrl: string = '';
  
  constructor(private readonly router: Router) {}
  
  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentUrl = event.url;
    });
    this.currentUrl = this.router.url;
  }
  
  reloadPage(url: string | undefined) {
    if (!url) return;
    
    const isSameUrl = this.router.url === url || (this.router.url.split('?')[0] === url.split('?')[0]); 
    // Activer l'indicateur de chargement meme si nous sommes déjà sur cette URL
    this.isLoading = true;
    
    // Ajouter un petit délai pour garantir un effet visuel
    setTimeout(() => {
      if (isSameUrl) {
        const timestamp = new Date().getTime();
        const refreshUrl = url.includes('?') 
          ? `${url}&_refresh=${timestamp}` 
          : `${url}?_refresh=${timestamp}`;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigateByUrl(refreshUrl).then(() => {
            history.replaceState({}, '', url);
            this.isLoading = false;
          });
        });
      } else {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([url]).then(() => {
            this.isLoading = false;
          });
        });
      }
    }, 100);
  }
}